module.exports = __webpack_public_path__ + "img/print-magnifying-glass.84823d12.svg";